<template>
  <div
    id="surgeryResult"
    class="section nomargin nopadding"
    :style="getBackground"
  >
    <div class="section nomargin" style="background: rgba(0,0,0,0.3);">
      <div class="container clearfix">
        <div class="heading-block dark nobottomborder nobottommargin center">
          <div class="divider divider-short divider-center">
            <i class="icon-circle-blank"></i>
          </div>

          <div class="heading-block center bottommargin-sm nobottomborder">
            <h2 class="nott" style="font-size: 46px;">
              {{ $t('consumersatisfaction') }}
              <!-- 한국 소비자 만족지수  -->
              <br />
              {{ $t('consumersatisfactiongrade') }}
              <!-- 3년 연속 1위 선정 -->
            </h2>
            <span>
              {{ $t('surgeryresult') }}
              <!-- 포헤어의 자연스럽고
              <br />
              <b>확실한 결과</b> -->
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="container clearfix">
      <div class="clear"></div>
      <div class="row">
        <div class="col-lg-6 topmargin bottommargin">
          <div class="team team-list clearfix">
            <div class="team-image">
              <div class="clear"></div>
              <TwentyTwenty
                offset="0.7"
                before="//www.forhair.co.kr/common/album/ba/20190719554439408971_0.jpg"
                after="//www.forhair.co.kr/common/album/ba/20190719554439408971_1.jpg"
              />
            </div>
            <div class="team-desc">
              <div class="team-title in-dark">
                <h4>
                  <h4>
                    {{ $t('forhairforwoman') }}
                    <!-- 여성 헤어라인 교정 -->
                  </h4>
                  <span>
                    <!-- [비절개부분삭발] 1700모낭 12개월후 -->
                    [{{ $t('partialshaving') }}] 1700 {{ $t('follicles') }} 12{{ $t('mafter') }} 
                  </span>
                </h4>
              </div>
              <div class="team-content">
                <p>
                  {{ $t('deschairline') }}
                  <!-- 자연스러운 고밀도 이식으로 이마 높이와 라인이 자연스럽게
                  교정됩니다. -->
                </p>
              </div>
            </div>
          </div> 
        </div>

        <div class="col-lg-6 topmargin bottommargin">
          <div class="team team-list clearfix">
            <div class="team-image ">
              <TwentyTwenty
                class="twentytwenty-container"
                offset="0.7"
                before="//www.forhair.co.kr/common/album/ba/20190719557275804892_0.jpg"
                after="//www.forhair.co.kr/common/album/ba/20190719557275804892_1.jpg"
              />
            </div>
            <div class="team-desc">
              <div class="team-title in-dark">
                <h4 class="in-dark">
                  {{ $t('forhairforman') }}
                  <!-- 남성 모발이식 -->
                </h4>
                <span>
                  [{{ $t('partialshaving') }}] 1600 {{ $t('follicles') }} 7{{ $t('mafter') }} 
                  <!-- [비절개부분삭발] 1600모낭 7개월후  -->
                </span>
              </div>
              <div class="team-content">
                <p>
                  {{ $t('mstress') }}
                  <!-- 남들은 몰라도 스트레스인 M자 탈모<br />적은 모낭으로도 이렇게
                  풍성해집니다. -->
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TwentyTwenty from "vue-twentytwenty";

export default {
  name: "LandingSurgeryResult",
  components: {
    TwentyTwenty
  },
  data() {
    return {
      bgImg: require("@/assets/images/bg/award-dark.png")
    };
  },
  computed: {
    getBackground() {
      return {
        "background-image": "url(" + this.bgImg + ")",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      };
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
